import { apiB2B, apiB2C } from '../axios-client';
import { mapResponseToCustomerModel, mapTradeTypes } from '../../utils/general';
import { B2B_ACCOUNT_PROFILE_PATH, B2B_TRADE_TYPES_PATH, B2B_UPDATE_PROFILE_PATH, B2C_ACCOUNT_PROFILE_PATH, B2C_TRADE_TYPES_PATH, UPDATE_TO_PRO_PATH, } from '../../constants/links';
export var accountApi = {
    profileDetails: function (isB2B) {
        if (isB2B) {
            return apiB2B
                .get(B2B_ACCOUNT_PROFILE_PATH)
                .then(function (_a) {
                var data = _a.data;
                return mapResponseToCustomerModel(data);
            });
        }
        return apiB2C
            .get(B2C_ACCOUNT_PROFILE_PATH)
            .then(function (_a) {
            var data = _a.data;
            return mapResponseToCustomerModel(data);
        });
    },
    updateProfileDetails: function (requestData, isB2B, token) {
        if (isB2B) {
            return apiB2B
                .post(B2B_UPDATE_PROFILE_PATH, requestData, { headers: { 'google-auth': token || '' } })
                .then(function (_a) {
                var data = _a.data;
                return mapResponseToCustomerModel(data);
            })
                .catch(function (error) {
                var _a, _b, _c, _d, _e;
                var errorCode = (_e = (_d = (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.accountProfile) === null || _c === void 0 ? void 0 : _c.errors) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.errorCode;
                return Promise.reject(errorCode);
            });
        }
        return apiB2C
            .put(B2C_ACCOUNT_PROFILE_PATH, requestData, {
            headers: { 'google-auth': token || '' },
        })
            .then(function (_a) {
            var data = _a.data;
            return mapResponseToCustomerModel(data);
        })
            .catch(function (error) {
            var _a, _b, _c, _d, _e;
            var errorCode = (_e = (_d = (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.account) === null || _c === void 0 ? void 0 : _c.errors) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.errorCode;
            return Promise.reject(errorCode);
        });
    },
    updateCompanyDetails: function (requestData, token) {
        return apiB2B
            .put(B2B_UPDATE_PROFILE_PATH, requestData, {
            headers: { 'google-auth': token || '' },
        })
            .then(function (_a) {
            var data = _a.data;
            return mapResponseToCustomerModel(data);
        })
            .catch(function (error) {
            var _a, _b, _c, _d, _e;
            var errorCode = (_e = (_d = (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.accountProfile) === null || _c === void 0 ? void 0 : _c.errors) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.errorCode;
            return Promise.reject(errorCode);
        });
    },
    updateToPro: function () {
        return apiB2C.get(UPDATE_TO_PRO_PATH, { data: null });
    },
    getTradeTypes: function (isB2B) {
        return isB2B
            ? apiB2B.get(B2B_TRADE_TYPES_PATH)
            : apiB2C
                .get(B2C_TRADE_TYPES_PATH)
                .then(function (_a) {
                var data = _a.data;
                return ({ data: mapTradeTypes(data) });
            });
    },
};
